import axios from 'axios'
import { one } from 'webmango-utils'

const { gapi } = global

let authInfo
let authClient

const fetchAuthInfo = one(async function fetchAuthInfo () {
  const { data } = await axios('/auth/info')
  return {
    ...data,
    client_id: data.clientID,
    scope: data.scope.join(' '),
    'requestvisibleactions': 'http://schema.org/CommentAction'
  }
})

const fetchLogout = one(async function fetchLogout () {
  return axios.get('/auth/logout')
})

const loadGAPI = one(async function loadAuth () {
  if (!gapi.auth2) {
    return new Promise((resolve, reject) => {
      gapi.load('auth2', {
        callback: resolve,
        onerror: reject
      })
    })
  }
})

export async function initAuth () {
  if (!authClient) {
    await loadGAPI()
    const info = await getAuthInfo()
    authClient = await gapi.auth2.init(info)
  }
  return authClient
}

export async function getAuthInstance () {
  await initAuth()
  return gapi.auth2.getAuthInstance()
}

export async function getAuthInfo () {
  if (!authInfo) {
    authInfo = await fetchAuthInfo()
  }
  return authInfo
}

export async function authToken ({ accessToken, ...data }) {
  try {
    const response = await axios.post('/auth/google', { accessToken, ...data })
    return response.data
  } catch (err) {
    let error = err
    if (error.response && error.response.status === 401) {
      error = new Error('User has no access to WebMango')
      if (err.request) error.request = err.request
      if (err.response) error.response = err.response
    }
    throw error
  }
}

export async function getProfile () {
  const { data } = await axios.get('/api/profile')
  return data
}

export async function getIsSignedIn () {
  const auth = await getAuthInstance()
  return auth.isSignedIn.get()
}

export async function logout () {
  await fetchLogout()
  const auth = await getAuthInstance()
  await auth.signOut()
}

window.auth = {
  logout,
  getAuthInfo,
  initAuth,
  getAuthInstance,
  getIsSignedIn
}



// WEBPACK FOOTER //
// ../webmango-core/effects/auth.js